import { render, staticRenderFns } from "./CategoryEditModal.vue?vue&type=template&id=675c666c&scoped=true"
import script from "./CategoryEditModal.vue?vue&type=script&lang=js"
export * from "./CategoryEditModal.vue?vue&type=script&lang=js"
import style0 from "./CategoryEditModal.vue?vue&type=style&index=0&id=675c666c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c666c",
  null
  
)

export default component.exports